import { RangeSetBuilder } from '@codemirror/state';
import { Decoration, EditorView, type DecorationSet } from '@codemirror/view';
import type { MutableRefObject } from 'react';
import type { YamlDiffLineMapping } from './guidelineSideBySideDiff';

function buildDecorationSet(
  state: EditorView['state'],
  side: 'left' | 'right',
  mappings: YamlDiffLineMapping[],
  activeRowIndex: number | null
): DecorationSet {
  const builder = new RangeSetBuilder<Decoration>();

  for (const mapping of mappings) {
    const lineNo = side === 'left' ? mapping.leftLine : mapping.rightLine;
    const kind = side === 'left' ? mapping.leftKind : mapping.rightKind;
    if (lineNo == null || lineNo < 1 || lineNo > state.doc.lines) continue;

    const isRemove = side === 'left' && kind === 'remove';
    const isAdd = side === 'right' && kind === 'add';
    if (!isRemove && !isAdd) continue;

    const classes = [
      isRemove ? 'cm-diff-line-remove' : 'cm-diff-line-add',
      activeRowIndex === mapping.rowIndex ? 'cm-diff-line-active' : '',
    ]
      .filter(Boolean)
      .join(' ');

    const line = state.doc.line(lineNo);
    builder.add(line.from, line.from, Decoration.line({ class: classes }));
  }

  return builder.finish();
}

export function yamlDiffDecorationsFromRefs(
  side: 'left' | 'right',
  mappingsRef: MutableRefObject<YamlDiffLineMapping[]>,
  activeRowIndexRef: MutableRefObject<number | null>
) {
  return EditorView.decorations.compute(['doc'], (state) =>
    buildDecorationSet(state, side, mappingsRef.current, activeRowIndexRef.current)
  );
}

export function refreshDiffDecorations(view: EditorView | null | undefined) {
  if (!view) return;
  view.dispatch({});
}
